const locale = require('./checklist.i18n.json');

/*@ngInject*/
const ChecklistController = function ($rootScope, $sce, $scope, $stateParams, authorizationConstants,
                                      checkListItemSubType, checkListItemType, coreConstant, quoteMediator,
                                      submissionConstant, wizardMediator, submissionStateMediator, checklistMediator,
                                      currentUserModel) {

    let wizardContextType = wizardMediator.getContextType(),
        wizardContextId = wizardMediator.getContextId();

    $scope.i18n = locale;

    $scope.viewModel = {
        checklistItemGroups: {},
        isOpen: false,
        isLoading: false,
        isSearchOpen: false,
        searchInput: '',
        searchDelayInMilliSeconds: submissionConstant.searchDelay,
        hasCheckLOAPermission: currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_CHECK_LOA_CHECKLIST_ITEM),
        openGroups: [],
        searchPlaceholder: $scope.i18n.searchPlaceholder,
        commentPlaceholder: $scope.i18n.commentPlaceholder,
        submissionGroupHeader: $scope.i18n.submissionGroupHeader
    };

    function saveState() {
        let toOmit = [
            'checklistItemList',
            'isLoading'
        ];
        submissionStateMediator.saveChecklistState($stateParams.submissionId, _.omit($scope.viewModel, toOmit));
    }

    function getObjectId(objectUri) {
        let uriSplits = _.split(objectUri, '/'),
            entityId = parseInt(uriSplits[2]);
        return entityId;
    }

    function processChecklistGroups(groups) {
        return _.forEach(groups, function (group) {
            let isGroupOpen = false,
                groupMatchesContext = false,
                proposalId;

            if (group.subGroups) {
                processChecklistGroups(group.subGroups);
            }

            if (_.includes(group.objectUri, 'Submission')) {
                group.header = $scope.viewModel.submissionGroupHeader;
                groupMatchesContext = true;
            } else if (_.includes(group.objectUri, 'Proposal')) {
                if (wizardContextType === submissionConstant.CONTEXT_PROPOSAL) {
                    groupMatchesContext = parseInt(wizardContextId) === getObjectId(group.objectUri);
                } else if (wizardContextType === submissionConstant.CONTEXT_QUOTE) {
                    proposalId = parseInt(_.split(wizardContextId, '::')[1]);
                    groupMatchesContext = proposalId === getObjectId(group.objectUri);
                }
            }

            if ($scope.viewModel.searchInput) {
                group.items = _.filter(group.items, function (item) {
                    return _.includes(_.lowerCase($scope.getItemDescription(item)), _.lowerCase($scope.viewModel.searchInput));
                });
            }

            group.showGroup = (group.proposalGroup || (group.items.length > 0));
            isGroupOpen = groupMatchesContext || group.isOpen || _.includes($scope.viewModel.openGroups, group.header);
            group.isOpen = isGroupOpen;

            _.forEach(group.items, function (item) {
                let checkListText;
                if(item.definition) {
                    checkListText = _.replace(item.definition.name, 'href="event:', 'href="');
                    item.definition.name = $sce.trustAsHtml(checkListText);
                }
                else {
                    checkListText = _.replace(item.description, 'href="event:', 'href="');
                    item.description = $sce.trustAsHtml(checkListText);
                }

                item.showCommentBox = item.comment;
            });
        });
    }

    function refreshChecklist(silentUpdate) {
        if ($scope.viewModel.isOpen) {
            if (!silentUpdate) {
                $scope.viewModel.isLoading = true;
            }

            checklistMediator.getChecklistItems($stateParams.submissionId).then(function (checklistResponse) {
                $scope.viewModel.checklistItemGroups = processChecklistGroups(checklistResponse.groups);
                $scope.viewModel.isLoading = false;
            }, function () {
                $scope.viewModel.isLoading = false;
            });
        }
    }

    function openDrawer() {
        $scope.viewModel.isOpen = true;
        refreshChecklist();
        saveState();
        $rootScope.$broadcast(submissionConstant.event.CHECKLIST_DID_OPEN);
    }

    function closeDrawer() {
        $scope.viewModel.isOpen = false;
        saveState();
        $rootScope.$broadcast(submissionConstant.event.CHECKLIST_DID_CLOSE);
    }

    function restoreState() {
        let savedViewModel = submissionStateMediator.getChecklistState($stateParams.submissionId);

        if (savedViewModel) {
            savedViewModel.hasCheckLOAPermission = $scope.viewModel.hasCheckLOAPermission;
            $scope.viewModel = _.extend($scope.viewModel, savedViewModel);

            if ($scope.viewModel.isOpen) {
                $rootScope.$broadcast(submissionConstant.event.CHECKLIST_DID_OPEN);
            }
        }
    }

    $scope.toggleCommentBox = function (checklistItem) {
        checklistItem.showCommentBox = !checklistItem.showCommentBox;
        if (!checklistItem.showCommentBox) {
            checklistItem.comment = null;
        }

    };

    $scope.toggleChecklistItemGroup = function (checklistItemGroup) {
        checklistItemGroup.isOpen = !checklistItemGroup.isOpen;
        if (checklistItemGroup.isOpen) {
            if (!_.includes($scope.viewModel.openGroups, checklistItemGroup.header)) {
                $scope.viewModel.openGroups.push(checklistItemGroup.header);
            }
        } else {
            _.remove($scope.viewModel.openGroups, function (openGroup) {
                return openGroup === checklistItemGroup.header;
            });
        }
        saveState();
    };

    $scope.isAuthorityItem = function (checklistItem) {
        return checklistItem.type !== checkListItemType.USER && checklistItem.subType !== checkListItemSubType.NONE;
    };

    $scope.isComplete = function (checklistItem) {
        return $scope.isAuthorityItem(checklistItem) && checklistItem.subType === checkListItemSubType.UNDERWRITING_AUTHORITY_APPROVED;
    };

    $scope.canCheckItem = function (checklistItem) {
        let isAuthorityItem = checklistItem.subType === checkListItemSubType.UNDERWRITING_AUTHORITY || checklistItem.subType === checkListItemSubType.UNDERWRITING_AUTHORITY_APPROVED;
        if (isAuthorityItem) {
            return $scope.viewModel.hasCheckLOAPermission;
        }
        return true;
    };

    $scope.handleUpdateChecklistItem = function (checklistItem) {
        checklistMediator.updateChecklistItem(checklistItem.id, checklistItem.checked, checklistItem.comment).then(function () {
            refreshChecklist(true);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST_ITEM_COUNT);
        });
    };

    $scope.handleDefinitionClick = function (checklistItem) {
        if ($scope.canCheckItem(checklistItem)) {
            checklistItem.checked = !checklistItem.checked;
            $scope.handleUpdateChecklistItem(checklistItem);
        }
    };

    $scope.onToggleChecklist = function () {
        return !$scope.viewModel.isOpen ? openDrawer() : closeDrawer();
    };

    $scope.onClearSearchInput = function () {
        $scope.viewModel.searchInput = '';
        refreshChecklist();
    };

    $scope.onSearchInputChange = function () {
        refreshChecklist();
    };

    $scope.getItemDescription = function (checklistItem) {
        if (checklistItem.definition) {
            return checklistItem.definition.name;
        }
        else {
            return checklistItem.description;
        }
    };

    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
        if (parseInt($stateParams.submissionId) === submission.id) {
            refreshChecklist(true);
        }
    });

    $scope.$on(submissionConstant.event.REFRESH_CHECKLIST, function (event, submissionId) {
        if (parseInt($stateParams.submissionId) === submissionId) {
            refreshChecklist(true);
            $rootScope.$broadcast(submissionConstant.event.REFRESH_CHECKLIST_ITEM_COUNT);
        }
    });

    $scope.$on(submissionConstant.event.CLOSE_CHECKLIST, function (event) {
        closeDrawer();
    });

    $scope.$on(submissionConstant.event.TOGGLE_CHECKLIST, function (event) {
        $scope.onToggleChecklist();
    });

    $scope.$on(submissionConstant.event.CONTEXT_CHANGED, function (event) {
        $scope.viewModel.openGroups = [$scope.viewModel.submissionGroupHeader];
        saveState();
        refreshChecklist();
    });

    restoreState();
    refreshChecklist();
};

angular.module('gw-um-submission')
    .controller('checklistController', ChecklistController);
